import {homePathGenerator} from "../../../api-client/core/authentication/utils";
import {makeImageUrlWithSize} from "../HomeElements/utils";
import {Link} from "react-router-dom";
import React from "react";

const CategoryItem = ({contentCreatorType, width}) => {
  return (
    <Link className="smart-search-bloom-item"
          to={homePathGenerator(`busqueda-inteligente/contenido?type=${contentCreatorType.slug}`)}>
      <div className="smart-search-category-bloom">
        <div className="smart-search-category-bloom-title"
             style={{color: width > 900 ? "black" : "white"}}>{contentCreatorType.name}{contentCreatorType.brand ==="bigCreator" && " (Big Creators)"}</div>
        <div className="smart-search-category-bloom-image"
             style={{backgroundImage: `url(${makeImageUrlWithSize(contentCreatorType, 'category-md')})`}}/>
        <div className="smart-search-category-bloom-fade"/>
      </div>
    </Link>
  )
}
export default CategoryItem